/* eslint camelcase: 0 */
import common from './common/en_US';
import confirmation from './confirmation/en_US';
import dapps from './dapps/en_US';
import header from './header/en_US';
import home from './home/en_US';
import footer from './footer/en_US';
import gettingStarted from './getting-started/en_US';
import privacyPolicy from './privacy-policy/en_US';
import termsAndConditions from './terms-of-conditions/en_US';
import createWallet from './create-wallet/en_US';
import accessWallet from './access-wallet/en_US';
import interfaceTranslations from './interface/en_US';
import team from './team/en_US';
import popover from './popover/en_US';
import withoutWallet from './without-wallet/en_US';
import errorsGlobal from './errors-global/en_US';
import trezorError from './errors-trezor/en_US';
import ledgerError from './errors-ledger/en_US';
import secalotError from './errors-secalot/en_US';
import keepkeyError from './errors-keepkey/en_US';
import bitboxError from './errors-bitbox/en_US';

const en_US = {
  common: common,
  confirmation: confirmation,
  dapps: dapps,
  header: header,
  home: home,
  footer: footer,
  gettingStarted: gettingStarted,
  privacyPol: privacyPolicy,
  termsOfConditions: termsAndConditions,
  team: team,
  accessWallet: accessWallet,
  createWallet: createWallet,
  interface: interfaceTranslations,
  popover: popover,
  withoutWallet: withoutWallet,
  errorsGlobal: errorsGlobal,
  trezorError: trezorError,
  ledgerError: ledgerError,
  secalotError: secalotError,
  keepkeyError: keepkeyError,
  bitboxError: bitboxError
};
export default en_US;
